import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { Link } from 'react-router-dom';

import { Checkbox } from '~/components/isolated/Checkbox';

import styles from './ProductInfoC.module.scss';

export interface ProductInfoCProps {
  /**
   * Product name
   */
  name: string;

  /**
   * Product URL slug for link
   */
  productSlug: string;

  /**
   * Current offer SKU
   */
  currentSku: string;

  /**
   * Checkbox checked state
   */
  isSelected?: boolean;

  /**
   * Checkbox onChange handler
   */
  onSelectionChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;

  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * ProductInfoC - Info section for horizontal cart card (variant C)
 *
 * Displays:
 * - Product name with link + Checkbox on the right
 */
const ProductInfoC: React.FC<ProductInfoCProps> = observer(
  ({
    name,
    productSlug,
    currentSku,
    isSelected = false,
    onSelectionChange,
    className,
  }) => {
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      onSelectionChange?.(e);
    };

    return (
      <div className={classes([styles.container, className])}>
        <div className={styles.headerRow}>
          <Link
            to={
              currentSku
                ? `/p/${productSlug}?sku=${encodeURIComponent(currentSku)}`
                : `/p/${productSlug}`
            }
            className={styles.name}
            data-link={`productCard:open-${currentSku}`}
          >
            {name}
          </Link>
          {onSelectionChange && (
            <Checkbox
              checked={isSelected}
              onChange={handleCheckboxChange}
              size={24}
              className={styles.checkboxWrapper}
            />
          )}
        </div>
      </div>
    );
  },
);

export default ProductInfoC;
